<template>
    <div class="backendFilter-container">
        <!-- <div class="mask"></div> -->
    </div>
</template>

<script>

    export default {
        data() {
            return {
                
            }
        },
        mounted() {
            this.$backendFilterBox()
        }
    }
</script>

<style lang="less" scoped>

</style>